import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;


export const sendFinishedCustomerEvaluation = async (customerEvaluationDTO: any,
                                                     ticketUniqueCode: string,
                                                     supervisorSignature: any,
                                                     technicianSignature: any) => {
    try {
        let formData = new FormData();

        // Function to handle Base64 and Blob signatures
        const appendSignatureToForm = async (signature: string, fieldName: string) => {
            if (signature.startsWith("data:image")) {
                // Convert Base64 to Blob
                const byteCharacters = atob(signature.split(",")[1]);
                const byteNumbers = new Uint8Array(
                    Array.from(byteCharacters, (char) => char.charCodeAt(0))
                );
                const blob = new Blob([byteNumbers], {type: "image/png"});

                // Append file to FormData
                formData.append(fieldName, blob, `${fieldName}-signature.png`);
            } else {
                // If it's already a Blob URL, fetch and send it
                const response = await fetch(signature);
                const blob = await response.blob();
                formData.append(fieldName, blob, `${fieldName}-signature.png`);
            }
        };

        if (supervisorSignature) {
            await appendSignatureToForm(supervisorSignature, "supervisorSignature");
        }

        if (technicianSignature) {
            await appendSignatureToForm(technicianSignature, "technicianSignature");
        }

        // Convert customerEvaluationDTO to a JSON Blob
        const jsonBlob = new Blob([JSON.stringify(customerEvaluationDTO)], {type: "application/json"});
        formData.append("customerEvaluation", jsonBlob);

        return await axios.post(
            `${API_BASE_URL}/customerEvaluations/ticket/${ticketUniqueCode}`,
            formData,
            {
                withCredentials: true,
                headers: {
                    "Content-Type": "multipart/form-data",
                },
            }
        );
    } catch (error: any) {
        if (error.response) {
            throw new Error(error.response.data.message || "Error al registrar información.");
        } else if (error.request) {
            throw new Error("No se puede conectar al servidor.");
        } else {
            throw new Error(error.message || "Error inesperado.");
        }
    }


}